
//Get user info from localstorage
export const allowUser = (users) => {
    if (users.user.status === 'APL' || users.user.status === 'BLI' || users.user.status === 'REG') {
        setLocalStorage("token", users.token);
        return true;
    }
    return false;
}
export const allowAdmin = (users) => {
    if (users.user.role === 'admin') {
        setLocalStorage("token", users.token);
        return true;
    }
    return false;
}
export const isAuth = (data) => {
    // Check if data exists and is a valid string
    if (!data || typeof data !== 'string' || data.trim() === '') {
        return false;
    }

    const token = data.trim();
    
    // Check if token has the correct JWT format (3 parts separated by dots)
    if (token.split('.').length !== 3) {
        return false;
    }

    const parseJwt = (token) => {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            return null;
        }
    };
    
    const decodedJwt = parseJwt(token);

    // If token cannot be decoded, return false
    if (!decodedJwt) {
        return false;
    }

    // Check if token is expired
    if (decodedJwt.exp && decodedJwt.exp * 1000 < new Date().getTime()) {
        // Don't clear localStorage here, let the component handle it
        // localStorage.clear();
        return false;
    }

    return decodedJwt;
}
export const setLocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));

};
export const removeLocalStorage = () => {
    localStorage.clear();
};

